import React from "react";
import BaseDetails, { DetailRow, TypeBadge } from "./baseDetails";
import snakeToPascal from "../../tools";

export default function ModelDataValueUpdateDetailsBase({ children, row }) {
    return (
        <BaseDetails row={row}>
            {row.model_data_value_name && (
                <DetailRow label="Field">
                    {snakeToPascal(row.model_data_value_name)}
                </DetailRow>
            )}
            <DetailRow label="Value Type">
                <TypeBadge>{snakeToPascal(row.model_data_value_type)}</TypeBadge>
            </DetailRow>
            {children}
        </BaseDetails>
    );
}
